import { render } from "./Confidentialite.vue?vue&type=template&id=6ebe48cc"
import script from "./Confidentialite.vue?vue&type=script&lang=js"
export * from "./Confidentialite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__